export const operationsAlertsTranslations = {
  de: {
    title: 'Betriebsalarme per E-Mail',
    description:
      'Betriebszustände überwachen, Empfänger und Versandgrenzen festlegen und den Verlauf prüfen.',
    configuration: 'Alarmkonfiguration',
    defaultsHint:
      'Standardmäßig ausgeschaltet. Neue Störungen und Wiederherstellungen werden protokolliert; Erinnerungen sind optional.',
    help: 'Hilfe zu Betriebsalarmen',
    enabled: 'E-Mail-Alarme aktivieren',
    smtpConfigured: 'SMTP ist eingerichtet',
    smtpMissing: 'SMTP ist nicht eingerichtet',
    infrastructureHint:
      'Betriebsalarme verwenden die SMTP-Einstellungen des aktuellen Mandanten unter Einstellungen → Mailserver & Backups. Die dortige Versandsperre blockiert auch Alarme. Ein deaktivierter Kundenmail-Funktionsschalter allein blockiert Alarme nicht. Frühere Umgebungsempfänger aktivieren Alarme nicht automatisch.',
    readOnly:
      'Sie können diese Einstellungen ansehen. Änderungen erfordern das Konfigurationsrecht.',
    recipientsHint:
      'Bis zu {{max}} Adressen; durch Zeilenumbruch, Komma oder Semikolon trennen. Ein Versand an die gesamte Liste zählt als ein Versuch.',
    countingHint:
      'Grenzen gelten für gleitende Zeitfenster und berücksichtigen auch fehlgeschlagene oder unklare Versandversuche. Neustarts setzen die Grenzen nicht zurück. Ausschalten erhält den Verlauf.',
    loadingSettings: 'Alarmeinstellungen werden geladen',
    settingsError: 'Alarmeinstellungen konnten nicht geladen werden.',
    save: 'Alarmeinstellungen speichern',
    saving: 'Wird gespeichert …',
    saved: 'Alarmeinstellungen gespeichert.',
    saveError: 'Speichern fehlgeschlagen. Ihre Eingaben bleiben erhalten. Bitte erneut versuchen.',
    conflict:
      'Diese Einstellungen wurden anderweitig geändert. Laden Sie die aktuellen Einstellungen ausdrücklich, bevor Sie Ihren Entwurf ersetzen.',
    loadCurrent: 'Aktuelle Einstellungen laden',
    discardDescription:
      'Ihre ungespeicherten Eingaben werden verworfen und durch die aktuellen gespeicherten Einstellungen ersetzt.',
    discardAndLoad: 'Änderungen verwerfen und laden',
    refreshSettings: 'Einstellungen aktualisieren',
    unsaved: 'Ungespeicherte Änderungen',
    updatedAt: 'Zuletzt gespeichert: {{date}}',
    fields: {
      enabled: 'E-Mail-Alarme',
      recipients: 'Empfänger',
      minimumIntervalMinutes: 'Mindestabstand (Minuten)',
      maxPerMinute: 'Maximum in den letzten 60 Sekunden',
      maxPerHour: 'Maximum in den letzten 60 Minuten',
      maxPerDay: 'Maximum in den letzten 24 Stunden',
      repeatIntervalMinutes: 'Erinnerungsabstand (Minuten)',
      version: 'Einstellungsstand',
    },
    hints: {
      minimumIntervalMinutes:
        'Mindestzeit zwischen Versandversuchen; 0 schaltet nur diesen Abstand aus.',
      maxPerMinute: 'Gleitendes Fenster von 60 Sekunden.',
      maxPerHour: 'Gleitendes Fenster von 60 Minuten.',
      maxPerDay: 'Gleitendes Fenster von 24 Stunden.',
      repeatIntervalMinutes:
        '0 bedeutet keine wiederholte Erinnerung. Sonst mindestens der Mindestabstand.',
    },
    validation: {
      summary: 'Markierte Felder prüfen. Ihre Eingaben bleiben erhalten.',
      recipientsRequired: 'Zum Aktivieren mindestens einen Empfänger angeben.',
      email: 'Gültige E-Mail-Adressen eingeben.',
      duplicates: 'Jeder Empfänger darf nur einmal vorkommen.',
      tooMany: 'Höchstens {{max}} Empfänger angeben.',
      number: 'Eine ganze Zahl von {{min}} bis {{max}} eingeben.',
      repeatInterval:
        'Der Erinnerungsabstand muss null oder mindestens so groß wie der Mindestabstand sein.',
    },
    history: {
      title: 'Alarmverlauf',
      retained: 'Ereignisse bleiben auch bei ausgeschalteten E-Mail-Alarmen verfügbar.',
      loading: 'Alarmverlauf wird geladen',
      error: 'Alarmverlauf konnte nicht geladen werden.',
      empty: 'Noch keine Alarmereignisse.',
      emptyHint: 'Die nächste erkannte Zustandsänderung erscheint hier.',
      noMatches: 'Keine Ereignisse für diese Filter.',
      refresh: 'Verlauf aktualisieren',
      clearFilters: 'Filter zurücksetzen',
      eventFilter: 'Ereignisfilter',
      deliveryFilter: 'Versandfilter',
      allEvents: 'Alle Ereignisse',
      allDeliveries: 'Alle Versandzustände',
      occurredAt: 'Erkannt am',
      event: 'Ereignis',
      environment: 'Umgebung',
      delivery: 'Versand',
      sentAt: 'Versandt am',
      notSent: 'Nicht versandt',
      details: 'Details',
      viewDetails: 'Ereignisdetails ansehen',
      pagination: 'Alarmverlauf-Seiten',
      page: 'Seite {{page}} von {{pages}} · {{total}} Ereignisse',
      previous: 'Vorherige Seite',
      next: 'Nächste Seite',
      snapshotHint:
        'Zustand bei Erkennung: Komponentenstatus und Zähler, ohne vertrauliche Geschäftsdaten.',
      components: 'Komponenten bei Erkennung',
      queueBacklog: 'Wartende Aufträge',
      failedJobs: 'Fehlgeschlagene Aufträge',
      demoDataDetected: 'Demodaten erkannt',
      yes: 'Ja',
      no: 'Nein',
    },
    events: {
      DEGRADED: 'Störung erkannt',
      RECOVERED: 'Betrieb wiederhergestellt',
      REMINDER: 'Erinnerung an offene Störung',
    },
    deliveryStates: {
      DISABLED: 'E-Mail-Alarme ausgeschaltet',
      PENDING: 'Versand ausstehend',
      LIMITED: 'Durch Versandgrenze zurückgehalten',
      SUPERSEDED: 'Durch neueren Zustand ersetzt',
      SENDING: 'Versand läuft',
      SENT: 'Versandt',
      FAILED: 'Versand fehlgeschlagen',
      UNCERTAIN: 'Versandergebnis unklar',
    },
    limitReasons: {
      INTERVAL: 'Mindestabstand noch nicht erreicht',
      MINUTE: 'Minutengrenze erreicht',
      HOUR: 'Stundengrenze erreicht',
      DAY: 'Tagesgrenze erreicht',
    },
    checkStatuses: {
      up: 'Verfügbar',
      warning: 'Warnung',
      down: 'Nicht verfügbar',
      disabled: 'Deaktiviert',
    },
    checks: {
      database: 'Datenbank',
      redis: 'Zwischenspeicher und Auftragsvermittlung',
      worker: 'Hintergrundverarbeitung',
      queues: 'Auftragswarteschlangen',
      backup: 'Datensicherung',
      offsiteSnapshot: 'Externe Sicherungskopie',
      restoreDrill: 'Wiederherstellungsprüfung',
      smtp: 'E-Mail-Versand',
      dms: 'Dokumentenablage',
      ollama: 'Lokale KI-Verarbeitung',
      whisper: 'Spracherkennung',
      openBanking: 'Bankanbindung',
      host: 'Serverressourcen',
      other: 'Weitere Komponente',
    },
  },
  en: {
    title: 'Operations email alarms',
    description:
      'Monitor operational health, configure recipients and sending limits, and inspect event history.',
    configuration: 'Alarm configuration',
    defaultsHint:
      'Disabled by default. New incidents and recoveries are recorded; reminders are optional.',
    help: 'Operations alarm help',
    enabled: 'Enable email alarms',
    smtpConfigured: 'SMTP is configured',
    smtpMissing: 'SMTP is not configured',
    infrastructureHint:
      'Las alertas usan los ajustes SMTP de esta empresa en Ajustes → Servidor de correo y copias de seguridad. El bloqueo del envío también bloquea las alertas. El ajuste de correos de clientes por sí solo no las bloquea. Los destinatarios antiguos del entorno no las activan automáticamente.',
    readOnly: 'You can view these settings. Configuration permission is required to change them.',
    recipientsHint:
      'Up to {{max}} addresses; separate with new lines, commas or semicolons. Sending to the entire list counts as one attempt.',
    countingHint:
      'Limits use rolling windows and also count failed or uncertain sending attempts. Restarts do not reset limits. Disabling alarms retains history.',
    loadingSettings: 'Loading alarm settings',
    settingsError: 'Alarm settings could not be loaded.',
    save: 'Save alarm settings',
    saving: 'Saving…',
    saved: 'Alarm settings saved.',
    saveError: 'Saving failed. Your entries are retained. Please try again.',
    conflict:
      'These settings changed elsewhere. Load the current settings explicitly before replacing your draft.',
    loadCurrent: 'Load current settings',
    discardDescription:
      'Your unsaved entries will be discarded and replaced with the current saved settings.',
    discardAndLoad: 'Discard changes and load',
    refreshSettings: 'Refresh settings',
    unsaved: 'Unsaved changes',
    updatedAt: 'Last saved: {{date}}',
    fields: {
      enabled: 'Email alarms',
      recipients: 'Recipients',
      minimumIntervalMinutes: 'Minimum interval (minutes)',
      maxPerMinute: 'Maximum in the last 60 seconds',
      maxPerHour: 'Maximum in the last 60 minutes',
      maxPerDay: 'Maximum in the last 24 hours',
      repeatIntervalMinutes: 'Reminder interval (minutes)',
      version: 'Settings revision',
    },
    hints: {
      minimumIntervalMinutes:
        'Minimum time between sending attempts; 0 disables this interval only.',
      maxPerMinute: 'Rolling 60-second window.',
      maxPerHour: 'Rolling 60-minute window.',
      maxPerDay: 'Rolling 24-hour window.',
      repeatIntervalMinutes:
        '0 means no repeated reminder. Otherwise use at least the minimum interval.',
    },
    validation: {
      summary: 'Check the highlighted fields. Your entries are retained.',
      recipientsRequired: 'Add at least one recipient to enable alarms.',
      email: 'Enter valid email addresses.',
      duplicates: 'Each recipient may appear only once.',
      tooMany: 'Enter no more than {{max}} recipients.',
      number: 'Enter a whole number from {{min}} to {{max}}.',
      repeatInterval: 'The reminder interval must be zero or at least the minimum interval.',
    },
    history: {
      title: 'Alarm history',
      retained: 'Events remain available when email alarms are disabled.',
      loading: 'Loading alarm history',
      error: 'Alarm history could not be loaded.',
      empty: 'No alarm events yet.',
      emptyHint: 'The next detected health change will appear here.',
      noMatches: 'No events match these filters.',
      refresh: 'Refresh history',
      clearFilters: 'Clear filters',
      eventFilter: 'Event filter',
      deliveryFilter: 'Delivery filter',
      allEvents: 'All events',
      allDeliveries: 'All delivery states',
      occurredAt: 'Detected at',
      event: 'Event',
      environment: 'Environment',
      delivery: 'Delivery',
      sentAt: 'Sent at',
      notSent: 'Not sent',
      details: 'Details',
      viewDetails: 'View event details',
      pagination: 'Alarm history pages',
      page: 'Page {{page}} of {{pages}} · {{total}} events',
      previous: 'Previous page',
      next: 'Next page',
      snapshotHint:
        'Health at detection: component states and counts, without sensitive business data.',
      components: 'Components at detection',
      queueBacklog: 'Queued jobs',
      failedJobs: 'Failed jobs',
      demoDataDetected: 'Demo data detected',
      yes: 'Yes',
      no: 'No',
    },
    events: {
      DEGRADED: 'Incident detected',
      RECOVERED: 'Service recovered',
      REMINDER: 'Ongoing incident reminder',
    },
    deliveryStates: {
      DISABLED: 'Email alarms disabled',
      PENDING: 'Awaiting delivery',
      LIMITED: 'Held by sending limit',
      SUPERSEDED: 'Replaced by newer state',
      SENDING: 'Sending',
      SENT: 'Sent',
      FAILED: 'Delivery failed',
      UNCERTAIN: 'Delivery outcome uncertain',
    },
    limitReasons: {
      INTERVAL: 'Minimum interval not yet reached',
      MINUTE: 'Minute limit reached',
      HOUR: 'Hourly limit reached',
      DAY: 'Daily limit reached',
    },
    checkStatuses: {
      up: 'Available',
      warning: 'Warning',
      down: 'Unavailable',
      disabled: 'Disabled',
    },
    checks: {
      database: 'Database',
      redis: 'Cache and job coordination',
      worker: 'Background worker',
      queues: 'Job queues',
      backup: 'Backup',
      offsiteSnapshot: 'Offsite backup copy',
      restoreDrill: 'Restore verification',
      smtp: 'Email delivery',
      dms: 'Document storage',
      ollama: 'Local AI processing',
      whisper: 'Speech recognition',
      openBanking: 'Bank connection',
      host: 'Server resources',
      other: 'Other component',
    },
  },
  tr: {
    title: 'İşletim e-posta alarmları',
    description:
      'İşletim durumunu izleyin, alıcıları ve gönderim sınırlarını ayarlayın, olay geçmişini inceleyin.',
    configuration: 'Alarm yapılandırması',
    defaultsHint:
      'Varsayılan olarak kapalıdır. Yeni arızalar ve düzelmeler kaydedilir; hatırlatmalar isteğe bağlıdır.',
    help: 'İşletim alarmı yardımı',
    enabled: 'E-posta alarmlarını etkinleştir',
    smtpConfigured: 'SMTP yapılandırılmış',
    smtpMissing: 'SMTP yapılandırılmamış',
    infrastructureHint:
      'İşletim uyarıları bu şirketin Ayarlar → Posta sunucusu ve yedeklemeler bölümündeki SMTP ayarlarını kullanır. Buradaki gönderim engeli uyarıları da engeller. Müşteri e-posta özellik anahtarı tek başına uyarıları engellemez. Eski ortam alıcıları uyarıları otomatik etkinleştirmez.',
    readOnly: 'Bu ayarları görüntüleyebilirsiniz. Değiştirmek için yapılandırma yetkisi gerekir.',
    recipientsHint:
      'En fazla {{max}} adres; satır sonu, virgül veya noktalı virgülle ayırın. Tüm listeye gönderim tek deneme sayılır.',
    countingHint:
      'Sınırlar kayan zaman aralıklarını kullanır; başarısız veya belirsiz denemeler de sayılır. Yeniden başlatma sınırları sıfırlamaz. Kapatma geçmişi korur.',
    loadingSettings: 'Alarm ayarları yükleniyor',
    settingsError: 'Alarm ayarları yüklenemedi.',
    save: 'Alarm ayarlarını kaydet',
    saving: 'Kaydediliyor…',
    saved: 'Alarm ayarları kaydedildi.',
    saveError: 'Kaydetme başarısız. Girdileriniz korundu. Yeniden deneyin.',
    conflict:
      'Bu ayarlar başka bir yerde değiştirildi. Taslağınızı değiştirmeden önce güncel ayarları açıkça yükleyin.',
    loadCurrent: 'Güncel ayarları yükle',
    discardDescription:
      'Kaydedilmemiş girdileriniz silinecek ve güncel kayıtlı ayarlarla değiştirilecektir.',
    discardAndLoad: 'Değişiklikleri sil ve yükle',
    refreshSettings: 'Ayarları yenile',
    unsaved: 'Kaydedilmemiş değişiklikler',
    updatedAt: 'Son kayıt: {{date}}',
    fields: {
      enabled: 'E-posta alarmları',
      recipients: 'Alıcılar',
      minimumIntervalMinutes: 'Asgari aralık (dakika)',
      maxPerMinute: 'Son 60 saniyedeki üst sınır',
      maxPerHour: 'Son 60 dakikadaki üst sınır',
      maxPerDay: 'Son 24 saatteki üst sınır',
      repeatIntervalMinutes: 'Hatırlatma aralığı (dakika)',
      version: 'Ayar sürümü',
    },
    hints: {
      minimumIntervalMinutes:
        'Gönderim denemeleri arasındaki asgari süre; 0 yalnız bu aralığı kapatır.',
      maxPerMinute: 'Kayan 60 saniyelik aralık.',
      maxPerHour: 'Kayan 60 dakikalık aralık.',
      maxPerDay: 'Kayan 24 saatlik aralık.',
      repeatIntervalMinutes:
        '0 tekrarlanan hatırlatmayı kapatır. Diğer değerler asgari aralıktan küçük olmamalıdır.',
    },
    validation: {
      summary: 'İşaretli alanları kontrol edin. Girdileriniz korundu.',
      recipientsRequired: 'Alarmları etkinleştirmek için en az bir alıcı ekleyin.',
      email: 'Geçerli e-posta adresleri girin.',
      duplicates: 'Her alıcı yalnız bir kez yer alabilir.',
      tooMany: 'En fazla {{max}} alıcı girin.',
      number: '{{min}} ile {{max}} arasında bir tam sayı girin.',
      repeatInterval: 'Hatırlatma aralığı sıfır veya en az asgari aralık kadar olmalıdır.',
    },
    history: {
      title: 'Alarm geçmişi',
      retained: 'E-posta alarmları kapalıyken olaylar erişilebilir kalır.',
      loading: 'Alarm geçmişi yükleniyor',
      error: 'Alarm geçmişi yüklenemedi.',
      empty: 'Henüz alarm olayı yok.',
      emptyHint: 'Algılanan sonraki durum değişikliği burada görünür.',
      noMatches: 'Bu filtrelere uyan olay yok.',
      refresh: 'Geçmişi yenile',
      clearFilters: 'Filtreleri temizle',
      eventFilter: 'Olay filtresi',
      deliveryFilter: 'Gönderim filtresi',
      allEvents: 'Tüm olaylar',
      allDeliveries: 'Tüm gönderim durumları',
      occurredAt: 'Algılanma zamanı',
      event: 'Olay',
      environment: 'Ortam',
      delivery: 'Gönderim',
      sentAt: 'Gönderim zamanı',
      notSent: 'Gönderilmedi',
      details: 'Ayrıntılar',
      viewDetails: 'Olay ayrıntılarını görüntüle',
      pagination: 'Alarm geçmişi sayfaları',
      page: 'Sayfa {{page}} / {{pages}} · {{total}} olay',
      previous: 'Önceki sayfa',
      next: 'Sonraki sayfa',
      snapshotHint:
        'Algılama anındaki durum: bileşen durumları ve sayılar; hassas iş verileri içermez.',
      components: 'Algılama anındaki bileşenler',
      queueBacklog: 'Kuyruktaki işler',
      failedJobs: 'Başarısız işler',
      demoDataDetected: 'Demo verisi algılandı',
      yes: 'Evet',
      no: 'Hayır',
    },
    events: {
      DEGRADED: 'Arıza algılandı',
      RECOVERED: 'Hizmet düzeldi',
      REMINDER: 'Devam eden arıza hatırlatması',
    },
    deliveryStates: {
      DISABLED: 'E-posta alarmları kapalı',
      PENDING: 'Gönderim bekleniyor',
      LIMITED: 'Gönderim sınırı nedeniyle bekletiliyor',
      SUPERSEDED: 'Daha yeni durumla değiştirildi',
      SENDING: 'Gönderiliyor',
      SENT: 'Gönderildi',
      FAILED: 'Gönderim başarısız',
      UNCERTAIN: 'Gönderim sonucu belirsiz',
    },
    limitReasons: {
      INTERVAL: 'Asgari aralık henüz dolmadı',
      MINUTE: 'Dakika sınırına ulaşıldı',
      HOUR: 'Saat sınırına ulaşıldı',
      DAY: 'Günlük sınıra ulaşıldı',
    },
    checkStatuses: {
      up: 'Kullanılabilir',
      warning: 'Uyarı',
      down: 'Kullanılamıyor',
      disabled: 'Devre dışı',
    },
    checks: {
      database: 'Veritabanı',
      redis: 'Önbellek ve iş koordinasyonu',
      worker: 'Arka plan işleyicisi',
      queues: 'İş kuyrukları',
      backup: 'Yedekleme',
      offsiteSnapshot: 'Harici yedek kopyası',
      restoreDrill: 'Geri yükleme doğrulaması',
      smtp: 'E-posta gönderimi',
      dms: 'Belge depolama',
      ollama: 'Yerel yapay zekâ işleme',
      whisper: 'Konuşma tanıma',
      openBanking: 'Banka bağlantısı',
      host: 'Sunucu kaynakları',
      other: 'Diğer bileşen',
    },
  },
  fr: {
    title: 'Alertes d’exploitation par e-mail',
    description:
      'Surveillez l’état des services, définissez les destinataires et les limites, puis consultez l’historique.',
    configuration: 'Configuration des alertes',
    defaultsHint:
      'Désactivé par défaut. Les incidents et rétablissements sont enregistrés ; les rappels sont facultatifs.',
    help: 'Aide sur les alertes d’exploitation',
    enabled: 'Activer les alertes par e-mail',
    smtpConfigured: 'SMTP est configuré',
    smtpMissing: 'SMTP n’est pas configuré',
    infrastructureHint:
      'Les alertes utilisent les paramètres SMTP de cette entreprise dans Paramètres → Serveur de messagerie et sauvegardes. Le blocage des e-mails y bloque également les alertes. Le seul réglage des e-mails clients ne les bloque pas. Les anciens destinataires d’environnement ne les activent pas automatiquement.',
    readOnly:
      'Vous pouvez consulter ces paramètres. Le droit de configuration est requis pour les modifier.',
    recipientsHint:
      'Jusqu’à {{max}} adresses, séparées par des retours à la ligne, virgules ou points-virgules. Un envoi à toute la liste compte pour une tentative.',
    countingHint:
      'Les limites suivent des fenêtres glissantes et comptent aussi les tentatives échouées ou incertaines. Un redémarrage ne les remet pas à zéro. La désactivation conserve l’historique.',
    loadingSettings: 'Chargement des paramètres d’alerte',
    settingsError: 'Impossible de charger les paramètres d’alerte.',
    save: 'Enregistrer les paramètres d’alerte',
    saving: 'Enregistrement…',
    saved: 'Paramètres d’alerte enregistrés.',
    saveError: 'Échec de l’enregistrement. Vos saisies sont conservées. Réessayez.',
    conflict:
      'Ces paramètres ont été modifiés ailleurs. Chargez explicitement les paramètres actuels avant de remplacer votre brouillon.',
    loadCurrent: 'Charger les paramètres actuels',
    discardDescription:
      'Vos saisies non enregistrées seront abandonnées et remplacées par les paramètres actuellement enregistrés.',
    discardAndLoad: 'Abandonner les modifications et charger',
    refreshSettings: 'Actualiser les paramètres',
    unsaved: 'Modifications non enregistrées',
    updatedAt: 'Dernier enregistrement : {{date}}',
    fields: {
      enabled: 'Alertes par e-mail',
      recipients: 'Destinataires',
      minimumIntervalMinutes: 'Intervalle minimal (minutes)',
      maxPerMinute: 'Maximum sur les 60 dernières secondes',
      maxPerHour: 'Maximum sur les 60 dernières minutes',
      maxPerDay: 'Maximum sur les 24 dernières heures',
      repeatIntervalMinutes: 'Intervalle des rappels (minutes)',
      version: 'Version des paramètres',
    },
    hints: {
      minimumIntervalMinutes:
        'Durée minimale entre les tentatives ; 0 désactive uniquement cet intervalle.',
      maxPerMinute: 'Fenêtre glissante de 60 secondes.',
      maxPerHour: 'Fenêtre glissante de 60 minutes.',
      maxPerDay: 'Fenêtre glissante de 24 heures.',
      repeatIntervalMinutes:
        '0 supprime les rappels répétés. Sinon, respecter au moins l’intervalle minimal.',
    },
    validation: {
      summary: 'Vérifiez les champs signalés. Vos saisies sont conservées.',
      recipientsRequired: 'Ajoutez au moins un destinataire pour activer les alertes.',
      email: 'Saisissez des adresses e-mail valides.',
      duplicates: 'Chaque destinataire ne peut figurer qu’une fois.',
      tooMany: 'Indiquez au maximum {{max}} destinataires.',
      number: 'Saisissez un entier de {{min}} à {{max}}.',
      repeatInterval:
        'L’intervalle des rappels doit être nul ou au moins égal à l’intervalle minimal.',
    },
    history: {
      title: 'Historique des alertes',
      retained:
        'Les événements restent disponibles lorsque les alertes par e-mail sont désactivées.',
      loading: 'Chargement de l’historique des alertes',
      error: 'Impossible de charger l’historique des alertes.',
      empty: 'Aucun événement d’alerte pour le moment.',
      emptyHint: 'Le prochain changement d’état détecté apparaîtra ici.',
      noMatches: 'Aucun événement ne correspond aux filtres.',
      refresh: 'Actualiser l’historique',
      clearFilters: 'Effacer les filtres',
      eventFilter: 'Filtre des événements',
      deliveryFilter: 'Filtre d’envoi',
      allEvents: 'Tous les événements',
      allDeliveries: 'Tous les états d’envoi',
      occurredAt: 'Détecté le',
      event: 'Événement',
      environment: 'Environnement',
      delivery: 'Envoi',
      sentAt: 'Envoyé le',
      notSent: 'Non envoyé',
      details: 'Détails',
      viewDetails: 'Afficher les détails de l’événement',
      pagination: 'Pages de l’historique des alertes',
      page: 'Page {{page}} sur {{pages}} · {{total}} événements',
      previous: 'Page précédente',
      next: 'Page suivante',
      snapshotHint:
        'État lors de la détection : composants et compteurs, sans données commerciales sensibles.',
      components: 'Composants lors de la détection',
      queueBacklog: 'Tâches en attente',
      failedJobs: 'Tâches échouées',
      demoDataDetected: 'Données de démonstration détectées',
      yes: 'Oui',
      no: 'Non',
    },
    events: {
      DEGRADED: 'Incident détecté',
      RECOVERED: 'Service rétabli',
      REMINDER: 'Rappel d’incident en cours',
    },
    deliveryStates: {
      DISABLED: 'Alertes par e-mail désactivées',
      PENDING: 'En attente d’envoi',
      LIMITED: 'Retenu par une limite d’envoi',
      SUPERSEDED: 'Remplacé par un état plus récent',
      SENDING: 'Envoi en cours',
      SENT: 'Envoyé',
      FAILED: 'Échec de l’envoi',
      UNCERTAIN: 'Résultat de l’envoi incertain',
    },
    limitReasons: {
      INTERVAL: 'Intervalle minimal non écoulé',
      MINUTE: 'Limite par minute atteinte',
      HOUR: 'Limite horaire atteinte',
      DAY: 'Limite quotidienne atteinte',
    },
    checkStatuses: {
      up: 'Disponible',
      warning: 'Avertissement',
      down: 'Indisponible',
      disabled: 'Désactivé',
    },
    checks: {
      database: 'Base de données',
      redis: 'Cache et coordination des tâches',
      worker: 'Traitement en arrière-plan',
      queues: 'Files de tâches',
      backup: 'Sauvegarde',
      offsiteSnapshot: 'Copie de sauvegarde externe',
      restoreDrill: 'Vérification de restauration',
      smtp: 'Envoi des e-mails',
      dms: 'Stockage des documents',
      ollama: 'Traitement IA local',
      whisper: 'Reconnaissance vocale',
      openBanking: 'Connexion bancaire',
      host: 'Ressources du serveur',
      other: 'Autre composant',
    },
  },
  es: {
    title: 'Alarmas operativas por correo',
    description:
      'Supervise los servicios, configure destinatarios y límites de envío y consulte el historial.',
    configuration: 'Configuración de alarmas',
    defaultsHint:
      'Desactivadas por defecto. Se registran incidencias y recuperaciones; los recordatorios son opcionales.',
    help: 'Ayuda sobre alarmas operativas',
    enabled: 'Activar alarmas por correo',
    smtpConfigured: 'SMTP está configurado',
    smtpMissing: 'SMTP no está configurado',
    infrastructureHint:
      'El envío usa el SMTP de infraestructura, independiente del correo de clientes. Se requiere SMTP configurado. Los destinatarios antiguos del entorno no activan las alarmas automáticamente.',
    readOnly:
      'Puede consultar estos ajustes. Se requiere permiso de configuración para modificarlos.',
    recipientsHint:
      'Hasta {{max}} direcciones, separadas por saltos de línea, comas o punto y coma. Un envío a toda la lista cuenta como un intento.',
    countingHint:
      'Los límites usan ventanas móviles y también cuentan intentos fallidos o inciertos. Reiniciar no restablece los límites. Desactivar conserva el historial.',
    loadingSettings: 'Cargando ajustes de alarmas',
    settingsError: 'No se pudieron cargar los ajustes de alarmas.',
    save: 'Guardar ajustes de alarmas',
    saving: 'Guardando…',
    saved: 'Ajustes de alarmas guardados.',
    saveError: 'No se pudo guardar. Se conservan sus entradas. Inténtelo de nuevo.',
    conflict:
      'Estos ajustes cambiaron en otro lugar. Cargue expresamente los ajustes actuales antes de reemplazar su borrador.',
    loadCurrent: 'Cargar ajustes actuales',
    discardDescription:
      'Se descartarán sus entradas sin guardar y se reemplazarán por los ajustes guardados actuales.',
    discardAndLoad: 'Descartar cambios y cargar',
    refreshSettings: 'Actualizar ajustes',
    unsaved: 'Cambios sin guardar',
    updatedAt: 'Último guardado: {{date}}',
    fields: {
      enabled: 'Alarmas por correo',
      recipients: 'Destinatarios',
      minimumIntervalMinutes: 'Intervalo mínimo (minutos)',
      maxPerMinute: 'Máximo en los últimos 60 segundos',
      maxPerHour: 'Máximo en los últimos 60 minutos',
      maxPerDay: 'Máximo en las últimas 24 horas',
      repeatIntervalMinutes: 'Intervalo de recordatorios (minutos)',
      version: 'Versión de ajustes',
    },
    hints: {
      minimumIntervalMinutes: 'Tiempo mínimo entre intentos; 0 desactiva solo este intervalo.',
      maxPerMinute: 'Ventana móvil de 60 segundos.',
      maxPerHour: 'Ventana móvil de 60 minutos.',
      maxPerDay: 'Ventana móvil de 24 horas.',
      repeatIntervalMinutes:
        '0 elimina recordatorios repetidos. En otro caso, use al menos el intervalo mínimo.',
    },
    validation: {
      summary: 'Revise los campos resaltados. Se conservan sus entradas.',
      recipientsRequired: 'Añada al menos un destinatario para activar las alarmas.',
      email: 'Introduzca direcciones de correo válidas.',
      duplicates: 'Cada destinatario solo puede aparecer una vez.',
      tooMany: 'Introduzca como máximo {{max}} destinatarios.',
      number: 'Introduzca un número entero de {{min}} a {{max}}.',
      repeatInterval: 'El intervalo de recordatorios debe ser cero o al menos el intervalo mínimo.',
    },
    history: {
      title: 'Historial de alarmas',
      retained: 'Los eventos siguen disponibles con las alarmas por correo desactivadas.',
      loading: 'Cargando historial de alarmas',
      error: 'No se pudo cargar el historial de alarmas.',
      empty: 'Todavía no hay eventos de alarma.',
      emptyHint: 'El próximo cambio de estado detectado aparecerá aquí.',
      noMatches: 'Ningún evento coincide con estos filtros.',
      refresh: 'Actualizar historial',
      clearFilters: 'Borrar filtros',
      eventFilter: 'Filtro de eventos',
      deliveryFilter: 'Filtro de envío',
      allEvents: 'Todos los eventos',
      allDeliveries: 'Todos los estados de envío',
      occurredAt: 'Detectado el',
      event: 'Evento',
      environment: 'Entorno',
      delivery: 'Envío',
      sentAt: 'Enviado el',
      notSent: 'Sin enviar',
      details: 'Detalles',
      viewDetails: 'Ver detalles del evento',
      pagination: 'Páginas del historial de alarmas',
      page: 'Página {{page}} de {{pages}} · {{total}} eventos',
      previous: 'Página anterior',
      next: 'Página siguiente',
      snapshotHint:
        'Estado al detectarse: componentes y contadores, sin datos empresariales sensibles.',
      components: 'Componentes al detectarse',
      queueBacklog: 'Trabajos en cola',
      failedJobs: 'Trabajos fallidos',
      demoDataDetected: 'Datos de demostración detectados',
      yes: 'Sí',
      no: 'No',
    },
    events: {
      DEGRADED: 'Incidencia detectada',
      RECOVERED: 'Servicio recuperado',
      REMINDER: 'Recordatorio de incidencia pendiente',
    },
    deliveryStates: {
      DISABLED: 'Alarmas por correo desactivadas',
      PENDING: 'Pendiente de envío',
      LIMITED: 'Retenido por límite de envío',
      SUPERSEDED: 'Sustituido por un estado más reciente',
      SENDING: 'Enviando',
      SENT: 'Enviado',
      FAILED: 'Envío fallido',
      UNCERTAIN: 'Resultado de envío incierto',
    },
    limitReasons: {
      INTERVAL: 'Intervalo mínimo aún no cumplido',
      MINUTE: 'Límite por minuto alcanzado',
      HOUR: 'Límite por hora alcanzado',
      DAY: 'Límite diario alcanzado',
    },
    checkStatuses: {
      up: 'Disponible',
      warning: 'Advertencia',
      down: 'No disponible',
      disabled: 'Desactivado',
    },
    checks: {
      database: 'Base de datos',
      redis: 'Caché y coordinación de trabajos',
      worker: 'Procesador en segundo plano',
      queues: 'Colas de trabajos',
      backup: 'Copia de seguridad',
      offsiteSnapshot: 'Copia de seguridad externa',
      restoreDrill: 'Verificación de restauración',
      smtp: 'Envío de correo',
      dms: 'Almacenamiento de documentos',
      ollama: 'Procesamiento local de IA',
      whisper: 'Reconocimiento de voz',
      openBanking: 'Conexión bancaria',
      host: 'Recursos del servidor',
      other: 'Otro componente',
    },
  },
} as const;
